import axios from 'axios';

export default {
    name: 'header',
    component() {
        return {
            open: false,
            scrollTop: 0,
            visible: false,
            sticky: false,
            offset: 90,
            lastScrollTop: 0,
            searchVal: "",
            suggestions: [],
            suggestionsQueriesCount: 0,
            suggestionsProductsCount: 0,
            isLoadingSuggestions: false,
            suggestDebounceTimer: null,
            locale: 'en',
            openSubheader: "",
            activeSubCollection: {
                title: "",
                handle: "",
                url: ""
            },

            init() {                
                let searchInput = document.querySelector('#search-filters input');
                // console.log(searchInput);
                searchInput.setAttribute('size',searchInput.getAttribute('placeholder').length);

                // Watch for search value changes to trigger predictive search
                this.$watch("searchVal", (val) => {
                    this.fetchSuggestions(val);
                });

                // Close suggestions when clicking outside
                this.$root.addEventListener('click', (e) => {
                    if (!e.target.closest('#search-filters')) {
                        this.suggestions = [];
                        this.suggestionsQueriesCount = 0;
                        this.suggestionsProductsCount = 0;
                    }
                });

                setTimeout(() => {
                    let headerHeight = document.querySelector('.header').getBoundingClientRect().height;
                    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

                    window.addEventListener("resize", () => {
                        let headerHeight = document.querySelector('.header').getBoundingClientRect().height;
                        if(this.sticky) {
                            headerHeight += 16;
                        }
                        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
                    });
                }, 100);

                this.stickyNav();
                window.addEventListener("scroll", () => {
                    this.stickyNav();
                });

                // this.$watch("openSubheader", (val) => {
                //     console.log(val);
                // });
            },

            fetchSuggestions(query) {
                // Clear previous debounce timer
                if (this.suggestDebounceTimer) {
                    clearTimeout(this.suggestDebounceTimer);
                }

                // If query is empty, clear suggestions
                if (!query || query.trim() === '') {
                    this.suggestions = [];
                    this.suggestionsQueriesCount = 0;
                    this.suggestionsProductsCount = 0;
                    return;
                }

                // Debounce the API call
                this.suggestDebounceTimer = setTimeout(() => {
                    this.isLoadingSuggestions = true;
                    const url = `/search/suggest.json?q=${encodeURIComponent(query)}`;
                    
                    axios.get(url)
                        .then((response) => {
                            // Shopify suggest API returns: { resources: { results: { products: [], queries: [], etc. } } }
                            const results = response.data.resources?.results || {};
                            console.log(results);
                            
                            // Only include queries and products (as requested)
                            const queries = results.queries || [];
                            const products = results.products || [];
                            
                            this.suggestions = [
                                ...queries.map(q => ({ ...q, type: 'query' })),
                                ...products.map(p => ({ ...p, type: 'product' }))
                            ];
                            
                            // Update counts
                            this.suggestionsQueriesCount = queries.length;
                            this.suggestionsProductsCount = products.length;
                            
                            this.isLoadingSuggestions = false;
                        })
                        .catch((error) => {
                            console.error('Error fetching search suggestions:', error);
                            this.suggestions = [];
                            this.suggestionsQueriesCount = 0;
                            this.suggestionsProductsCount = 0;
                            this.isLoadingSuggestions = false;
                        });
                }, 300); // 300ms debounce
            },

            selectSuggestion(suggestion) {
                // If suggestion has a URL (product), navigate to it
                if (suggestion.url) {
                    window.location.href = suggestion.url;
                    return;
                }
                
                // Otherwise, set the search value to the selected suggestion text (query)
                if (suggestion.text) {
                    this.searchVal = suggestion.text;
                } else if (suggestion.title) {
                    this.searchVal = suggestion.title;
                } else if (suggestion.query) {
                    this.searchVal = suggestion.query;
                }
                this.suggestions = [];
                this.suggestionsQueriesCount = 0;
                this.suggestionsProductsCount = 0;
            },

            stickyNav() {
                const top =
                    window.scrollY ||
                    window.scrollTop ||
                    document.getElementsByTagName("html")[0].scrollTop;
                let st = window.pageYOffset || document.documentElement.scrollTop;
        
                if (top > this.offset) {
                    this.sticky = true;
                    if (st > this.lastScrollTop) {
                        this.visible = false;
                        this.openSubheader = '';
                        this.lastScrollTop = st <= 0 ? 0 : st;
                    } else {
                        if (st + 100 < this.lastScrollTop) {
                            this.visible = true;
                            this.lastScrollTop = st <= 0 ? 0 : st;
                        }
                    }
                } else {
                    this.sticky = false;
                    this.visible = false;
                    this.lastScrollTop = st <= 0 ? 0 : st;
                }
            },
        }
    }
}